<template>
  <div
    :class="[
      'grid gap-x-8 md:grid-cols-3 lg:grid-cols-4 md:gap-x-16',
      columns === 1 ? 'grid-cols-1' : 'grid-cols-2',
    ]"
  >
    <OutletProductCard
      v-for="product in products"
      :key="product.objectID"
      :columns
      :device-type="getDeviceType(product)"
      :images="getProductImages(product)"
      :product
    />
  </div>
</template>

<script setup lang="ts">
import type { AlgoliaProduct } from '@backmarket/http-api/src/api-specs-search-reco/search/searchAlgolia'

import type { OutletDeviceType } from '~/scopes/outlet/composables/useProductImages/useProductImages'

import OutletProductCard from '../OutletProductCard/OutletProductCard.vue'

withDefaults(
  defineProps<{
    columns?: 1 | 2
    getDeviceType: (product: AlgoliaProduct) => OutletDeviceType | null
    getProductImages: (product: AlgoliaProduct) => string[]
    products: AlgoliaProduct[]
  }>(),
  {
    columns: 2,
  },
)
</script>
